export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const checkValidity = ( value, rules ) => {
    let isValid = true;
    if ( !rules ) {
        return true;
    }

    if ( rules.required ) {
        
        isValid = value.trim() != '' && isValid;
        if (!isValid){
        }
    }
    else if (value.trim() == '' || (rules.isNumeric && value =='0')) {
        return true;
    }

    if ( rules.minLength ) {
        isValid = value.length >= rules.minLength && isValid
        if (!isValid){
        }
    }

    if ( rules.maxLength ) {
        isValid = value.length <= rules.maxLength && isValid
        if (!isValid){
        }
    }

    if ( rules.isEmail ) {
        value = value.toLowerCase();
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        
        isValid = pattern.test( value ) && isValid
    }

    if ( rules.isNumeric ) {
        isValid = true;
        if (isNaN(value))
        {
            isValid = false;
            
        }
    }

    return isValid;
}



// WEBPACK FOOTER //
// ./src/shared/utility.js